/**
 * @module ChartSettingsPanel/utils/validationUtils
 * @description 双Y轴指标校验（与 ChartsDrop getDualYAxisMetricFieldErrors 逻辑一致）
 */

/**
 * 双Y轴指标筛选器校验
 *
 * @param mergedValues - merged(base, draft) 的当前值
 * @param totalMetricCount - QB 中全部指标数量
 * @returns 校验错误对象，无错误时 primary / secondary 均为 undefined
 */
export function validateDualYAxisMetrics(
  mergedValues: Record<string, unknown>,
  totalMetricCount: number,
): { primary?: string; secondary?: string } {
  const REQUIRED_ERROR_KEY = 'dbl_chart_dual_y_axis_metric_required';
  const ALLOCATION_ERROR_KEY = 'dbl_chart_dual_y_axis_metric_allocation_required';

  if (!mergedValues.dualYAxisEnabled) return {};

  const primaryMetricsRaw = Array.isArray(
    (mergedValues.primaryYAxis as Record<string, unknown>)?.metrics,
  )
    ? ((mergedValues.primaryYAxis as Record<string, unknown>).metrics as unknown[])
    : [];
  const secondaryMetricsRaw = Array.isArray(
    (mergedValues.secondYAxis as Record<string, unknown>)?.metrics,
  )
    ? ((mergedValues.secondYAxis as Record<string, unknown>).metrics as unknown[])
    : [];

  const primaryMetrics = primaryMetricsRaw
    .map((item) => (typeof item === 'string' ? item : (item as Record<string, string>)?.metric || ''))
    .filter(Boolean);
  const secondaryMetrics = secondaryMetricsRaw
    .map((item) => (typeof item === 'string' ? item : (item as Record<string, string>)?.metric || ''))
    .filter(Boolean);

  const result: { primary?: string; secondary?: string } = {};

  if (!primaryMetrics.length) {
    result.primary = REQUIRED_ERROR_KEY;
  }
  if (!secondaryMetrics.length) {
    result.secondary = REQUIRED_ERROR_KEY;
  }
  if (result.primary || result.secondary) {
    return result;
  }

  const assignedMetrics = [...primaryMetrics, ...secondaryMetrics];
  if (assignedMetrics.length !== totalMetricCount) {
    result.primary = ALLOCATION_ERROR_KEY;
    result.secondary = ALLOCATION_ERROR_KEY;
  }
  return result;
}
